import { useQuery } from '@apollo/client/react'
import type { ErrorLike } from '@apollo/client'

import { graphql } from '~publish/graphql'
import type { ResultOf, VariablesOf } from '~publish/graphql'

const GetPostingSchedulePreviewForChannel = graphql(/* GraphQL */ `
  query GetPostingSchedulePreviewForChannel(
    $input: PostingSchedulePreviewInput!
  ) {
    postingSchedulePreview(input: $input) {
      __typename
      current {
        day
        times
        paused
      }
      proposed {
        day
        times
        paused
      }
      diff {
        added {
          day
          time
        }
        removed {
          day
          time
        }
        unchanged {
          day
          time
        }
      }
    }
  }
`)

export type GetPostingSchedulePreviewPayload = ResultOf<
  typeof GetPostingSchedulePreviewForChannel
>

export type PostingScheduleStrategyInput = VariablesOf<
  typeof GetPostingSchedulePreviewForChannel
>['input']['strategy']

type UsePostingSchedulePreviewResult = {
  data?: GetPostingSchedulePreviewPayload
  error?: ErrorLike | undefined
  loading: boolean
}

export function usePostingSchedulePreview(args: {
  channelId: string
  strategy: PostingScheduleStrategyInput
}): UsePostingSchedulePreviewResult {
  const { channelId, strategy } = args

  const { loading, data, error } = useQuery(
    GetPostingSchedulePreviewForChannel,
    {
      fetchPolicy: 'network-only',
      variables: { input: { strategy, channelId } },
    },
  )

  return {
    data,
    error,
    loading,
  }
}
